import { Localizations } from '@eig-builder/module-localization'

Localizations.append({
  modules: {
    crm: {
      core: {
        refreshInterval: {
          info: 'Refresh interval will run every {0} seconds ({1} tries left)',
          disable: 'Disable',
          next: 'next',
          previous: 'previous'
        }
      }
    }
  }
})
